export const SET_MESSAGE_SAVE_STATE_ROUTE = 'SET_MESSAGE_SAVE_STATE_ROUTE';
export const setMessageSaveStateRoute = (messageSaveStateRoute) => (
  {
    type: SET_MESSAGE_SAVE_STATE_ROUTE,
    messageSaveStateRoute
  }
);

export const SET_DATA_ROUTE_FOR_EDIT = 'SET_DATA_ROUTE_FOR_EDIT';
export const setDataRouteForEdit = (dataRouteForEdit) => (
  {
    type: SET_DATA_ROUTE_FOR_EDIT,
    dataRouteForEdit
  }
);
